<template>
	<div></div>
</template>

<script>
export default {
	name: "popupPg",
	created() {
		fetch('/api/pg/config')
			.then(res => res.json())
			.then(data => {
				const scriptUrl = data.inicisTest
					? "https://stgstdpay.inicis.com/stdjs/INIStdPay_popup.js"
					: "https://stdpay.inicis.com/stdjs/INIStdPay_popup.js";
				return this.$loadScript(scriptUrl);
			})
			.catch(() => {
				alert("결제 설정을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.");
			});
	},
}
</script>

<style scoped>

</style>